import React from "react"
import {FieldManagementPreviewProps} from "../../../render/management-preview";


export default function FieldColor_ManagementPreview(props: FieldManagementPreviewProps) {

    // const model : any = {}
    // model[props.field.fieldId] = "Lorem Ipsum"

    // return <FieldView field={props.field} model={model} />
    return <div className={Classes("ui5-color-picker", "gd-c-1")}/>
}